/**
 * Sidebar Icon
 *
 */

export default function getting_started(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.25 5.25H18.75C19.1478 5.25 19.5294 5.40804 19.8107 5.68934C20.092 5.97064 20.25 6.35218 20.25 6.75V14.25C20.25 14.6478 20.092 15.0294 19.8107 15.3107C19.5294 15.592 19.1478 15.75 18.75 15.75H16.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V6.75C3.75 6.35218 3.90804 5.97064 4.18934 5.68934C4.47064 5.40804 4.85218 5.25 5.25 5.25H6.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5709 15.75C19.128 15.75 19.674 15.9051 20.1479 16.198C20.6217 16.4908 21.0047 16.9098 21.2539 17.408L23.0899 21.079C23.2043 21.3077 23.2583 21.5619 23.2468 21.8174C23.2354 22.0729 23.1587 22.3212 23.0243 22.5387C22.8898 22.7562 22.702 22.9358 22.4786 23.0603C22.2552 23.1848 22.0037 23.2501 21.7479 23.25H2.25191C1.99617 23.2501 1.74466 23.1848 1.52127 23.0603C1.29788 22.9358 1.11002 22.7562 0.975554 22.5387C0.841086 22.3212 0.764468 22.0729 0.752979 21.8174C0.741491 21.5619 0.795513 21.3077 0.909914 21.079L2.74591 17.408C2.9951 16.9098 3.37808 16.4908 3.85195 16.198C4.32582 15.9051 4.87186 15.75 5.42891 15.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 3.956C14.25 2.185 12 0.75 12 0.75C12 0.75 9.75 2.185 9.75 3.956V11.437H14.25V3.956Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75003 11.437H7.01203C6.92903 11.4385 6.84662 11.4227 6.77002 11.3907C6.69342 11.3587 6.6243 11.3111 6.56703 11.251C6.51568 11.1963 6.47945 11.1292 6.46192 11.0562C6.44438 10.9833 6.44615 10.9071 6.46703 10.835C6.73457 10.0927 7.17011 9.42235 7.73962 8.87626C8.30912 8.33017 8.99718 7.92315 9.75003 7.687"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 11.437H16.988C17.0708 11.4383 17.1531 11.4225 17.2295 11.3905C17.3059 11.3585 17.3748 11.311 17.432 11.251C17.4835 11.1964 17.5199 11.1293 17.5374 11.0563C17.555 10.9833 17.5531 10.907 17.532 10.835C17.2638 10.0932 16.8282 9.42334 16.259 8.87736C15.6897 8.33138 15.0023 7.92404 14.25 7.687"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 14.25V16.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 14.25V18.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
